// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"10b9f2ec","223":"0154d293","484":"acc45643","551":"2c3c6c29","598":"35a87970","891":"0059e4af"}[chunkId] + ".chunk.js";
};